/**
 * Shim for @clariness/box: re-exports with optional placeholder/onPointer* props
 * so React 19 types don't require them (theme-ui Pick<> types treat them as required).
 */
import React from 'react';
import { Box as OrigBox, type BoxProps } from '~clariness-box';

type OptionalPointerProps = {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
};

export type { BoxProps };
export const Box = OrigBox as React.ForwardRefExoticComponent<
  Omit<React.ComponentProps<typeof OrigBox>, keyof OptionalPointerProps> &
    OptionalPointerProps &
    React.RefAttributes<HTMLDivElement>
>;
